import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Animations, Classes, Events } from '../global/constants';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Menu ----------

	$Elements.HeaderWrapper.each(function() {

		Animations.global.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 1,
					end: 'max',
					onUpdate: (self) => {
						(self.progress > 0) ? this.classList.add(Classes.shrinkable) : this.classList.remove(Classes.shrinkable);
					}
				}
			});
		});
	});

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed):not(.transition-clone)').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	});

	// ---------- CTAs Fade-in ----------

	$('.aside-section').each(function() {

		Animations.mobile.min.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: 'bottom 96%',
					endTrigger: 'footer',
					end: 'bottom top',
					toggleClass: {
						targets: $('.form-column'),
						className: Classes.moving
					},
				}
			});
		});
	});

	// ---------- CTAs Fade-out-down Desktop ----------

	let sectionSelector;

	if($('.slider-page-section').length > 0) {
		sectionSelector = '.slider-page-section';
	}
	else {
		sectionSelector = '.newsletter-section';
	}

	$(sectionSelector).each(function() {
		Animations.mobile.min.push(() => {
			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: '10% bottom',
					endTrigger: 'footer',
					end: 'bottom top',
					toggleClass: {
						targets: $('.form-column'),
						className: Classes.fadeDown
					},
				}
			});
		});
	});

};

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
